<ng-template #contentHeaderTemplate></ng-template>

@if (patient) {
  <div class="d-flex flex-column h-100 w-100">
    <app-tab-switcher
      [config]="[
    {link: '/patients/' + this.patient!.id, translationKey: 'authenticated.patients.edit.tabs.details', exact: true},
    {link: '/patients/' + this.patient!.id + '/documents', translationKey: 'authenticated.patients.edit.tabs.documents', exact: true},
    {link: '/patients/' + this.patient!.id + '/emails', translationKey: 'authenticated.patients.edit.tabs.emails', exact: false},
    {link: '/patients/' + this.patient!.id + '/history', translationKey: 'authenticated.patients.edit.tabs.history', exact: false},
  ]"
    ></app-tab-switcher>

    <app-private-file-browser
      class="flex-grow-1"
      [itemName]="'authenticated.patients.documents.item_name' | translate"
      [privateAttachments]="patient.files ?? []"
      [privateAttachmentAttachableId]="patient.id"
      [privateAttachmentAttachableType]="PrivateAttachmentAttachableTypeEnum.PATIENTS"
      [privateAttachmentType]="PrivateAttachmentTypeEnum.PATIENT_FILE"
      [privateAttachmentMeta]="patient.meta.private_attachments"
      (reloadRequested)="onReloadRequested()"
    ></app-private-file-browser>
  </div>
}
